module.exports = __webpack_public_path__ + "media/images/app/products/rbtd-banner-71a8f166541d5ef1f531e4199b08ff49.webp";